import { type DOMProps } from "@simplybusiness/mobius";
import type React from "react";
import type { RefAttributes } from "react";
import type { WithMetadata } from "../../pages";
import type { SectionProps } from "./Section";
import type { RuleSet } from "./validation/form/types";
import { Questionnaire as StandardQuestionnaire } from "./Questionnaire";
import { StackedSectionsQuestionnaire } from "./StackedSectionsQuestionnaire";

export type QuestionnaireElement = HTMLDivElement;

export interface QuestionnaireProps
  extends DOMProps, RefAttributes<QuestionnaireElement> {
  config?: Record<string, unknown>;
  sections: SectionProps[];
  validations?: readonly RuleSet[];
  className?: string;
  elementType?: React.ElementType;
  pageId?: string;
  currentSection?: number;
  variant?: "stacked-sections";
  preamble?: string;
  preambleName?: string;
}

/**
 * Questionnaire component router.
 * Routes to the appropriate variant based on the variant prop.
 */
export const Questionnaire = ({
  ref,
  ...props
}: WithMetadata<QuestionnaireProps>) => {
  const { variant, ...otherProps } = props;

  // Stacked sections variant
  if (variant === "stacked-sections") {
    return (
      <StackedSectionsQuestionnaire
        {...otherProps}
        variant={variant}
        ref={ref}
      />
    );
  }

  // Default/standard variant
  return <StandardQuestionnaire {...otherProps} variant={variant} ref={ref} />;
};

Questionnaire.displayName = "Questionnaire";
